export default {
  clientId: "taxmon",
  entry: () => import("./main.jsx"),
};
